import React, { useState, useRef, useEffect } from 'react';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';

import './UserCopyMain.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )
})

const UserCopyMain = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])


  return(
    <div className="UserCopyContainer">
      <table className="UserCopyTable" width="100%">
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCopyTit">Base E-mail</span>
          </td>
          <td>
            <InputText onChange={props.handleEmail} value={props.email} name="email-textfield" type="text" className="box" id="textfield1" size="25" />
          </td>
        </tr>
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCopyTit">Copy E-mail</span>
          </td>
          <td>
            <InputText onChange={props.handleCopyEmail} value={props.copyemail} name="email-textfield" type="text" className="box" id="textfield1" size="25" />
          </td>
        </tr>
      </table>
      <div className="user-copy-save-box">
        <a className="button purple_line"  ref={tooltipTarget} onClick={()=>{props.handleCopy(); setTooltipShow(true)}}>복사</a>
        <TooltipWithTimer target={tooltipTarget} show={tooltipShow} tooltipDirection="top" tooltipText={props.saveTooltip} />
      </div>
    </div>
  )
}

export default UserCopyMain;
